import dashboardRoutes from './dashboard';
import registerRoutes from './register';
import loginRoutes from './login';

import PageNotFound from '@/views/404.vue';

const notFound = [
    {
        path: '*',
        component: PageNotFound,
    },
];

export default [
    ...dashboardRoutes,
    ...registerRoutes,
    ...loginRoutes,
    ...notFound,
];
